import { Injectable } from '@angular/core';
import { concat, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LifecyclesService {
  private hooks = {
    preAuth: [] as Array<() => Observable<void>>,
    postAuth: [] as Array<() => Observable<void>>,
    preAuthorization: [] as Array<() => Observable<void>>,
    postAuthorization: [] as Array<() => Observable<void>>,
    preLogout: [] as Array<() => Observable<void>>,
    postLogout: [] as Array<() => Observable<void>>,
  };

  addPreAuthHook(hook: () => Observable<void>): () => void {
    return this.addHook('preAuth', hook);
  }

  addPostAuthHook(hook: () => Observable<void>): () => void {
    return this.addHook('postAuth', hook);
  }

  addPreAuthorizationHook(hook: () => Observable<void>): () => void {
    return this.addHook('preAuthorization', hook);
  }

  addPostAuthorizationHook(hook: () => Observable<void>): () => void {
    return this.addHook('postAuthorization', hook);
  }

  addPreLogoutHook(hook: () => Observable<void>): () => void {
    return this.addHook('preLogout', hook);
  }

  addPostLogoutHook(hook: () => Observable<void>): () => void {
    return this.addHook('postLogout', hook);
  }

  private addHook(
    type: keyof typeof this.hooks,
    hook: () => Observable<void>
  ): () => void {
    this.hooks[type].push(hook);
    return () => {
      this.hooks[type] = this.hooks[type].filter((h) => h !== hook);
    };
  }

  executePreAuthHooks(): Observable<void> {
    return this.executeHooks('preAuth');
  }

  executePostAuthHooks(): Observable<void> {
    return this.executeHooks('postAuth');
  }

  executePreAuthorizationHooks(): Observable<void> {
    return this.executeHooks('preAuthorization');
  }

  executePostAuthorizationHooks(): Observable<void> {
    return this.executeHooks('postAuthorization');
  }

  executePreLogoutHooks(): Observable<void> {
    return this.executeHooks('preLogout');
  }

  executePostLogoutHooks(): Observable<void> {
    return this.executeHooks('postLogout');
  }

  private executeHooks(type: keyof typeof this.hooks): Observable<void> {
    if (this.hooks[type].length === 0) {
      return of(undefined);
    }

    const hookObservables = this.hooks[type].map((hook) => hook());
    return concat(...hookObservables);
  }
}
